import React, {Fragment} from 'react';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {MainHeader} from 'presentation/components/MainHeader';
import {translations} from 'presentation/translations-new';
import {Box, Stack} from '@mui/material';

import {CustomStepper} from 'presentation/components/CustomStepper';
import {StyledGrid} from 'presentation/components/Grid';
import {StepProgressBar} from 'presentation/components/StepProgressBar';
import {AbandonFlowModal, MainFooter, SwipeableEdgeDrawer} from 'presentation/components';
import {StyledBox} from './styles';
import {ChangeDialogsGroup} from 'presentation/modules/booking/shared/ui/components/ChangeDialogsGroup';
import {useExamBooking} from '../../../hooks/useExamBooking';
import {ExamSearchBar} from '../../components/ExamSearchBar';
import {ExamSummarySectionGroup} from '../../components/ExamSummarySectionGroup';
import {ExamStepsWrapper} from './steps/ExamStepsWrapper';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';

const {abandonFlow, appointmentSummary} = translations['pt-br'].privateFlow.bookingFlow;

export function ExamBooking() {
	const {
		getHeaderTitle,
		shouldHideBackBtn,
		stepLabels,
		searchBarPlaceholder,
		isLastStep,
		shouldHideSearchBar,
		handleClose,
		handleBack,
		handleConfirmExitFlow,
		showSwipeableDrawerBookingSummary,
		customFooterMarginBottom,
		handleNext,
		openDrawerState,
		setOpenDrawerState,
		abandonFlowState,
		setAbandonFlowState,
		handleChangeModals,
		showExamSummarySectionGroupInGrid,
		hideStepBar,
		isMobile,
		setActiveBookingFlowStep,
		activeBookingFlowStep,
		stepperActiveStep,
		shouldHideSearchBarAndBookingSummary,
		shouldUseNewResumeLayout,
	} = useExamBooking();

	return (
		<Fragment>
			<MainHeader
				title={getHeaderTitle()}
				dataTagId={{
					backButton: AppointmentBookingEnum.CLICK_VOLTAR_AGENDAMENTO,
					closeButton: AppointmentBookingEnum.CLICK_DESCARTAR_AGENDAMENTO,
				}}
				handleBack={handleBack}
				handleClose={handleClose}
				hideBackBtn={shouldHideBackBtn}
				variant="subRoute">
				{hideStepBar ? null : (
					<StyledGrid.Root px={isMobile ? 2 : 4} pb={3}>
						<StyledGrid.Item sm={12} md={12} lg={12}>
							<Stack gap={3}>
								{isMobile ? (
									<StepProgressBar
										mt={1}
										currentStep={stepperActiveStep + 1}
										totalSteps={stepLabels.length}
									/>
								) : (
									<CustomStepper
										dataTagId={AppointmentBookingEnum.NOME_STEP}
										activeStep={stepperActiveStep}
										stepLabels={stepLabels}
									/>
								)}
							</Stack>
						</StyledGrid.Item>
					</StyledGrid.Root>
				)}

				{shouldHideSearchBar ? null : (
					<ExamSearchBar
						activeStep={activeBookingFlowStep}
						placeholder={searchBarPlaceholder[activeBookingFlowStep]}
					/>
				)}
			</MainHeader>

			<StyledGrid.Root p={isMobile ? 2 : 4} height="100%">
				<StyledGrid.Item
					sm={12}
					md={12}
					lg={shouldHideSearchBarAndBookingSummary || shouldUseNewResumeLayout ? 12 : 8}>
					<ExamStepsWrapper
						activeStep={activeBookingFlowStep}
						handleBack={handleBack}
						handleNext={handleNext}
						stepLabels={stepLabels}
					/>
				</StyledGrid.Item>
				{showExamSummarySectionGroupInGrid ? (
					<StyledGrid.Item md={4} lg={4}>
						<ExamSummarySectionGroup
							handleBack={handleBack}
							activeStep={activeBookingFlowStep}
							handleChangeModals={handleChangeModals}
							stepLabels={stepLabels}
						/>
					</StyledGrid.Item>
				) : null}
			</StyledGrid.Root>

			<StyledBox
				$isLastStep={isLastStep}
				$adjustFooterMargin={shouldHideSearchBarAndBookingSummary}>
				<MainFooter customMarginBottom={customFooterMarginBottom()} />
			</StyledBox>
			{showSwipeableDrawerBookingSummary ? (
				<SwipeableEdgeDrawer
					type="with-appbar"
					title={appointmentSummary}
					open={openDrawerState}
					setOpen={setOpenDrawerState}
					customDrawerHeight={openDrawerState ? 'auto' : undefined}>
					<Box paddingInline={2} paddingBottom={2} height={'100%'} overflow={'auto'}>
						<ExamSummarySectionGroup
							activeStep={activeBookingFlowStep}
							handleBack={handleBack}
							handleChangeModals={handleChangeModals}
							stepLabels={stepLabels}
							showTitle={false}
							disableGutters={true}
						/>
					</Box>
				</SwipeableEdgeDrawer>
			) : null}

			<ChangeDialogsGroup
				flowType={FlowEnum.EXAM}
				setActiveBookingFlowStep={setActiveBookingFlowStep}
			/>

			<AbandonFlowModal
				open={abandonFlowState}
				setOpen={setAbandonFlowState}
				headerTitle={abandonFlow.headerTitle}
				title={abandonFlow.title}
				description={abandonFlow.examDescription}
				handleConfirm={handleConfirmExitFlow}
				confirmButtondataTagId={AppointmentBookingEnum.ABANDONOU_AGENDAMENTO}
				modaldataTagId={AppointmentBookingEnum.VISUALIZOU_MODAL_ABANDONO}
			/>
		</Fragment>
	);
}
